import itemStockTile from "./itemStockTile"

export const ItemStockTile = itemStockTile